import { Component, Input, OnInit } from '@angular/core';
import { HeaderGaleryComponent } from "../header-galery/header-galery.component";
import { HostingService } from '../../services/hosting.service';
import { ActivatedRoute } from '@angular/router';
import { Hosting } from '../../models/HostingModel';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-galery',
  imports: [
    HeaderGaleryComponent,
    CommonModule
  ],
  templateUrl: './galery.component.html',
  styleUrl: './galery.component.css'
})
export class GaleryComponent implements OnInit{
  @Input() hosting!: Hosting;
  modalOpen = false;
  currentModalImageIndex = 0;
  images: string[] = [];
  isMobile = window.innerWidth <= 640;

  constructor(public hostingService: HostingService, private route: ActivatedRoute,){}

  ngOnInit(): void {
    this.getHosting();
  }

  getHosting(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.hostingService.getHosting(id).subscribe((data) => {
        this.hosting = data;
        this.images = this.extractImages(data);
      });
    }
  }

  extractImages(hosting: Hosting): string[] {
    let imgs: string[] = [];
    if (Array.isArray(hosting.images)) {
      imgs = imgs.concat(hosting.images.filter((img: string) => !!img));
    } else if (typeof hosting.images === 'string' && hosting.images) {
      imgs.push(hosting.images);
    }
    if (hosting.room?.images) {
      imgs = imgs.concat(hosting.room.images.filter((img: string) => !!img));
    }
    return imgs;
  }
  openModal(index: number) {
    this.currentModalImageIndex = index;
    this.modalOpen = true;
  }

  closeModal() {
    this.modalOpen = false;
  }

  prevImage() {
    if (this.images.length > 1) {
      this.currentModalImageIndex = (this.currentModalImageIndex - 1 + this.images.length) % this.images.length;
    }
  }

  nextImage() {
    if (this.images.length > 1) {
      this.currentModalImageIndex = (this.currentModalImageIndex + 1) % this.images.length;
    }
  }

  getCurrentImage() {
    if (!this.images || this.images.length === 0) {
      return '';
    }
    return this.images[this.currentModalImageIndex];
  }

  onResize(event: any) {
    this.isMobile = event.target.innerWidth <= 640;
  }
}
 